module.exports = __webpack_public_path__ + "img/verification-process-1-en.82280b07.png";